import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { fetchFormData } from '../../../../../Api/ApiMethods';

const extractItems = (response) => {
    if (response?.isSuccess && Array.isArray(response?.data?.items)) {
        return response.data.items;
    }

    if (Array.isArray(response?.items)) {
        return response.items;
    }

    if (Array.isArray(response?.data)) {
        return response.data;
    }

    if (Array.isArray(response)) {
        return response;
    }

    return [];
};

const useCallFormLookups = ({ insuranceCompanyApiUrl, workFileTypeApiUrl, cityApiUrl, districtApiUrl, cityId }) => {
    const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    const [workFileTypes, setWorkFileTypes] = useState([]);
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [filteredDistricts, setFilteredDistricts] = useState([]);

    useEffect(() => {
        const fetchInsuranceCompanies = async () => {
            try {
                const response = await fetchFormData({
                    apiEndpoint: insuranceCompanyApiUrl,
                    page: 1,
                    pageSize: 100,
                    search: null,
                });

                const companies = extractItems(response).map((company) => ({
                    id: company.id,
                    name: company.name || company.title,
                    address: company.address,
                    phoneNumber: company.phoneNumber || company.phone,
                    email: company.email,
                    contactPerson: company.contactPerson,
                    website: company.website,
                    taxNumber: company.taxNumber,
                    ibanNumber: company.ibanNumber,
                }));

                setInsuranceCompanies(companies);
            } catch (error) {
                toast.error('Sigorta şirketleri yüklenirken bir hata oluştu.');
            }
        };

        fetchInsuranceCompanies();
    }, [insuranceCompanyApiUrl]);

    useEffect(() => {
        const fetchWorkFileTypes = async () => {
            try {
                const response = await fetchFormData({
                    apiEndpoint: workFileTypeApiUrl,
                    page: 1,
                    pageSize: 100,
                    search: null,
                });

                const fileTypes = extractItems(response).map((fileType) => ({
                    id: fileType.id,
                    title: fileType.title || fileType.name,
                    description: fileType.description,
                }));

                setWorkFileTypes(fileTypes);
            } catch (error) {
                toast.error('İş dosya türleri yüklenirken bir hata oluştu.');
                setWorkFileTypes([]);
            }
        };

        fetchWorkFileTypes();
    }, [workFileTypeApiUrl]);

    useEffect(() => {
        const fetchCities = async () => {
            try {
                const response = await fetchFormData({
                    apiEndpoint: cityApiUrl,
                    page: 1,
                    pageSize: 100,
                });

                setCities(extractItems(response));
            } catch (error) {
                toast.error('Şehirler alınırken hata oluştu.');
                setCities([]);
            }
        };

        fetchCities();
    }, [cityApiUrl]);

    useEffect(() => {
        const fetchDistricts = async () => {
            if (!cityId) {
                setDistricts([]);
                setFilteredDistricts([]);
                return;
            }

            try {
                const response = await fetchFormData({
                    apiEndpoint: `${districtApiUrl}?city=${cityId}`,
                    page: 1,
                    pageSize: 100,
                });

                const items = extractItems(response);
                setDistricts(items);
                setFilteredDistricts(items);
            } catch (error) {
                toast.error('İlçeler alınırken hata oluştu.');
                setDistricts([]);
                setFilteredDistricts([]);
            }
        };

        fetchDistricts();
    }, [cityId, districtApiUrl]);

    return {
        insuranceCompanies,
        workFileTypes,
        cities,
        districts,
        filteredDistricts,
    };
};

export default useCallFormLookups;
